import mastercardLogo from "../../../../../img/mastercard-logo.png";
import visaLogo from "../../../../../img/visa-logo.png";
import americanlogo from "../../../../../img/americanexpress-logo.png";
import edenredlogo from "../../../../../img/ednred-logo.png";
import sivalelogo from "../../../../../img/sivale-logo.png";
import sodexologo from "../../../../../img/sodexo-logo.png";
import carnetlogo from "../../../../../img/carnet-logo.png";

export const getCardImage = (brand) => {
    if (!brand) return null;
    switch (brand.toLowerCase()) {
      case "mastercard":
      case "master card":
        return mastercardLogo;
      case "visa":
        return visaLogo;
      case "american express":
        return americanlogo;
      case "carnet":
        return carnetlogo;
      case "sodexo":
        return sodexologo;
      case "sivale":
        return sivalelogo;
      case "edenred":
        return edenredlogo;
      default:
        return null;
    }
};
